import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=363811ba&scoped=true&style=background-color%3A%20%23EAEAEA"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"
import style0 from "./SuccessMessage.vue?vue&type=style&index=0&id=363811ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363811ba",
  null
  
)

export default component.exports